import React from "react";

import { Skeleton } from "../../ui/skeleton";
import { VStack } from "../../ui/vstack";

const BreakdownSkeleton = React.memo(() => (
  <VStack space="sm">
    <Skeleton isLoaded={false} className="h-4 rounded-md" />
    <Skeleton isLoaded={false} className="h-4 rounded-md" />
    <Skeleton isLoaded={false} className="h-4 rounded-md" />
    <Skeleton isLoaded={false} className="h-6 rounded-md" />
  </VStack>
));

BreakdownSkeleton.displayName = "BreakdownSkeleton";

export default BreakdownSkeleton;
